// React imports
import { useEffect, useState } from 'react';

// Components
import ScrollToTop from '../components/ScrollToTop.tsx';
import ModalContent from '../components/ModalContent.tsx';

// Contextes
import Container from '../components/Container.tsx';
import { useInTheGame } from '../utils/InTheGameContexte.tsx';

// Librairies
import ReactMarkdown from 'react-markdown';

// Data
import referencesData from '../data/references.ts';

function References() {
    // Toggle Game pour afficher le logo
    const { toggleGame } = useInTheGame();
    useEffect(() => {
        toggleGame(true);
    }, [toggleGame]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkHref, setLinkHref] = useState('');

    // Fonction pour gérer la confirmation avant de quitter la page
    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Empêcher la navigation par défaut
        e.preventDefault();
        setLinkHref(e.currentTarget.href);
        setIsModalOpen(true);
    };

    return (
        <>
            <ModalContent
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                linkHref={linkHref}
            />

            <Container color='white'>
                <section
                    className='refsContent'
                    id='reglesTitle'
                >
                    <h1 className='text-special text-special--red'>Références </h1>
                    <ul>
                        {referencesData.map((reference, index) => (
                            <li key={index}>
                                <span>{index + 1}</span>
                                <ReactMarkdown
                                    components={{
                                        p: ({ ...props }) => <p {...props} />,
                                        a: ({ ...props }) => (
                                            <a
                                                {...props}
                                                className='custom-link'
                                                onClick={handleLinkClick}
                                            />
                                        ),
                                    }}
                                >
                                    {reference}
                                </ReactMarkdown>
                            </li>
                        ))}
                    </ul>
                    <ScrollToTop sectionId='reglesTitle' />
                </section>
            </Container>
        </>
    );
}

export default References;
